import _ from 'lodash'
import {
  TEST_TYPE_LABELS,
  TEST_TYPES,
} from '@edulastic/constants/const/testTypes'

export const getAllTestTypesWithBaseType = (
  allUserTypes,
  requiredBaseTypes
) => {
  return [
    ...requiredBaseTypes,
    ...Object.values(allUserTypes)
      .filter(({ baseType }) => requiredBaseTypes.includes(baseType))
      .map(({ title }) => title),
  ]
}

export const getTestTypeLabel = (testType, userTestTypesInternal) => {
  return TEST_TYPE_LABELS[testType] ?? userTestTypesInternal[testType]?.title
}

export const getAllTestTypeLabels = (userTestTypesInternal) => {
  return Object.values(userTestTypesInternal).reduce(
    (pv, { title }) => ({ ...pv, [title]: title }),
    TEST_TYPE_LABELS
  )
}

export const convertTestTypesToConstant = (userTestTypesInternal) => {
  const allTestTypesInternal = _.cloneDeep(TEST_TYPES)
  Object.values(userTestTypesInternal).forEach(({ title, baseType }) => {
    Object.entries(TEST_TYPES).forEach(([key, values]) => {
      if (values.includes(baseType)) allTestTypesInternal[key].push(title)
    })
  })

  return allTestTypesInternal
}
